<template>
	<div class="row mt-4">
		<div class="col-12">
			<h3 class="text-dark m-0 p-0 py-2 px-2 border border-warning">
				{{ data.name }}
			</h3>
		</div>
		<div class="col-sm-12 px-2 mt-2">
			<h4 class="text-dark m-0 p-0 py-2 px-3">{{ data.overview }}</h4>
		</div>
		<div class="col-12 px-4 mt-4 d-flex flex-wrap">
			<span
				v-for="(city, index) in data.cities"
				:key="`${index}-cty`"
				class="city-container"
			>
				<span class="text-dark p-0 m-0 px-2 py-2 bg-info pill"
					>{{ city.city.name }} - {{ city.stayNights }}N</span
				>
				<i
					v-if="index < Object.keys(data.cities).length - 1"
					class="bi bi-caret-right-fill text-gray"
				></i>
			</span>
		</div>
		<div class="col-12 py-2 px-4 d-flex flex-wrap">
			<span
				class="fs-5 text-dark pill bg-warning me-2"
				v-for="(tag, index) in data.tags"
				:key="`${index}-tag`"
			>
				{{ tag.name }}
			</span>
		</div>
	</div>
	<div class="row my-5">
		<!-- <div class="col-sm-3">
			<h4 class="text-dark mb-4">Cities / Night Stay</h4>
			<table>
				<thead>
					<th class="text-dark">City</th>
					<th class="ps-4 text-dark">Night Stay</th>
				</thead>
				<tbody>
					<tr v-for="(city, index) in data.cities" :key="`${index}-cty`">
						<td class="text-dark">{{ city.city.name }}</td>
						<td class="ps-4 text-dark">{{ city.stayNights }}</td>
					</tr>
				</tbody>
			</table>
		</div> -->
		<div class="col-sm-5 px-2 inclusions">
			<h4 class="text-dark mb-4">The package price includes</h4>
			<p class="text-dark inclusions" v-html="data.inclusions"></p>
		</div>
		<!-- <div class="col-sm-1"></div> -->
		<div class="col-sm-5 px-2">
			<h4 class="text-dark mb-4">The package price excludes</h4>
			<p class="text-dark exclusions" v-html="data.exclusions"></p>
		</div>
	</div>

	<div class="row"></div>
	<div v-if="data.itinerary" class="row mt-4">
		<h4 class="text-dark">Itinerary</h4>
		<div
			v-for="(itinerary, index) in data.itineraryDayWise"
			:key="`${index}-itinerary`"
			class="col-sm-12 p-2"
		>
			<div class="card">
				<div class="row g-0">
					<div
						class="col-md-2 d-flex flex-column justify-content-evenly align-items-center overflow-hidden"
					>
						<div class="profile">
							<img
								class="user-profile round-img shadow-lg"
								:src="`${
									itinerary?.sightSeeing instanceof Array
										? itinerary?.sightSeeing[0]?.images[0]
										: ''
								}`"
								alt="sight"
							/>
						</div>
					</div>
					<div class="card-body col-sm-8">
						<h4 class="card-title pb-1">{{ itinerary.title }}</h4>
						<div class="row">
							<div class="col-sm-3">
								<p class="card-text pb-1"><b>Day </b>{{ itinerary.day }}</p>
							</div>
							<div class="col-sm-3">
								<p class="card-text pb-1">
									<b>City: </b>{{ itinerary.city.name }}
								</p>
							</div>
							<div class="col-sm-3">
								<p class="card-text pb-1">
									<b>Place: </b>{{ itinerary.placeName }}
								</p>
							</div>
							<div class="col-sm-3">
								<p class="card-text pb-1">
									<b>Meals: </b
									><span
										v-for="(meal, mealIndex) in itinerary.meal"
										:key="`${mealIndex}-meal`"
										>{{ meal }},
									</span>
								</p>
							</div>
						</div>

						<div
							v-for="(sight, index) in itinerary.sightSeeing"
							:key="`${index}-sight`"
							class="row my-2"
						>
							<h6>Sight {{ index + 1 }}</h6>
							<div class="col-sm-3">
								<p><b>Activity:</b> {{ sight.activity }}</p>
							</div>
							<div class="col-sm-3">
								<p><b>Duration:</b> {{ sight.duration }}</p>
							</div>
							<div class="col-sm-3">
								<p><b>Start Time:</b> {{ sight.startTime }}</p>
							</div>
							<div class="col-sm-3">
								<p><b>End Day:</b> {{ sight.closeDay }}</p>
							</div>
						</div>
						<div class="row">
							<p class="card-text pb-1">
								<b>Detail: </b>{{ itinerary.details }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-if="data?.includedDeal" class="row">
		<PackageHotelDealCard
			name="Bronze"
			:dealData="data.bronzePackage"
			:starCount="1"
		/>
		<PackageHotelDealCard
			name="Platinum"
			:dealData="data.platinumPackage"
			:starCount="2"
		/>
		<PackageHotelDealCard
			name="Silver"
			:dealData="data.silverPackage"
			:starCount="3"
		/>
		<PackageHotelDealCard
			name="Gold"
			:dealData="data.goldPackage"
			:starCount="4"
		/>
		<PackageHotelDealCard
			name="Luxury"
			:dealData="data.luxuryPackage"
			:starCount="5"
		/>
	</div>
</template>
<script>
	import { reactive, inject } from "vue";
	import PackageHotelDealCard from "./packageHotelDealCard.vue";
	export default {
		name: "PackageShow",
		components: {
			PackageHotelDealCard,
		},

		setup: () => {
			const masterStore = inject("masterStore");

			const data = reactive({
				name: masterStore.state.data.name,
				country: masterStore.state.data.country.name,
				cities: masterStore.state.data.cities,
				states: masterStore.state.data.states,
				tags: masterStore.state.data.tags,
				overview: masterStore.state.data.overview,
				meal: masterStore.state.data.meal,
				itinerary: masterStore.state.data.itinerary,
				itineraryDayWise: [],
				other: masterStore.state.data.other,
				images: masterStore.state.data.images,
				inclusions: masterStore.state.data.inclusions,
				exclusions: masterStore.state.data.exclusions,
				includedDeal: masterStore.state.data.includedDeal,
				luxuryPackage: masterStore.state.data.luxuryPackage,
				goldPackage: masterStore.state.data.goldPackage,
				silverPackage: masterStore.state.data.silverPackage,
				platinumPackage: masterStore.state.data.platinumPackage,
				bronzePackage: masterStore.state.data.bronzePackage,
			});

			const userImage = reactive({
				url: process.env.VUE_APP_IMAGE_PREFIX,
			});

			// sorting function for Itinerary array objects
			const dynamicSort = (property) => {
				const sortOrder = 1;

				return (a, b) => {
					// a should come before b in the sorted order
					if (a[property] < b[property]) {
						return -1 * sortOrder;
						// a should come after b in the sorted order
						// eslint-disable-next-line no-else-return
					} else if (a[property] > b[property]) {
						return 1 * sortOrder;
						// a and b are the same
					} else {
						return 0 * sortOrder;
					}
				};
			};

			data.itineraryDayWise = masterStore.state.data.itineraryDayWise.sort(
				dynamicSort("day"),
			);

			return { data, userImage };
		},
	};
</script>
<style scoped>
	.profile {
		height: 100%;
		width: 100%;

		overflow: hidden;
	}
	.user-profile {
		width: 100%;
		height: 100%;
		border-radius: 8px;
	}
	.inclusions > p,
	.exclusions > p {
		text-align: justify;
	}
	.city-container {
		width: fit-content;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>